/* eslint-disable no-use-before-define */
import React from 'react'
import { Head } from './head'
import { Body } from './body'
import { More } from './more'
import { useOrders } from '../use-orders'
import { Status } from '../../twd'
export const Grid = (args) => {

    let { rows, status, onLoadMore, count, shown, setShown } = useOrders()

    return <React.Fragment>

        {(status===Status.LOADED && rows.length>0) && (
            <div className="table-responsive">
            <table
                data-name="orders-table"
                className="table table-striped align-top"
            >
                <Head />
                <Body rows={rows} shown={shown} setShown={setShown} />
            </table>
            </div>
        )}

        <More
            rows={rows}
            status={status}
            count={count}
            onLoadMore={onLoadMore}
        />
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/orders/blotter/grid.js